import { useEffect, useRef, useState } from 'react'

export const useDomainChecker = (email) => {
  const [status, setStatus] = useState(null)
  const timer = useRef()

  useEffect(() => {
    if (!email || !email.includes('@') || email.length < 5) {
      setStatus(null)
      return
    }

    const domain = email.split('@')[1]
    setStatus('checking')
    clearTimeout(timer.current)

    timer.current = setTimeout(async () => {
      try {
        const res = await fetch('/api/check-domain', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ domain, skipRecaptcha: true }),
        })

        if (!res.ok) throw new Error('Domain check failed')
        const { status } = await res.json()
        setStatus(status === 'success' ? 'valid' : 'invalid')
      } catch {
        setStatus('invalid')
      }
    }, 2000)

    return () => clearTimeout(timer.current)
  }, [email])

  return status
}
